// Sidebar entries owned by the Business module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { resources, scopes } from '@vnetwork/datacentral-core/auth'
import { businessPaths } from './paths'

// The sidebar fields Business' entries use. Structurally the app's SidebarType
// (src/types/shared): src/app/nav.tsx places these entries, so a drift between
// the two fails typecheck there.
interface BusinessNavItem {
    title: string
    path: string
    rsname?: string
    require_scopes?: string[]
    visible_permission_denied?: boolean
}

export const businessNav = {
    manage: {
        title: 'business:sidebar_title',
        path: businessPaths.businessesManage,
        rsname: resources.business,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    account: {
        title: 'business-account',
        path: businessPaths.businessAccountList,
    },
} satisfies Record<string, BusinessNavItem>
